import { render, staticRenderFns } from "./Three-Grid.vue?vue&type=template&id=facdf4b8&scoped=true&"
import script from "./Three-Grid.vue?vue&type=script&lang=js&"
export * from "./Three-Grid.vue?vue&type=script&lang=js&"
import style0 from "./Three-Grid.vue?vue&type=style&index=0&id=facdf4b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facdf4b8",
  null
  
)

export default component.exports